module.exports = __webpack_public_path__ + "img/BCO.2045cb22.svg";